import { ResendSMSForSetupAccountRequestPayload } from "@/data/payload/user/re-send-sms-for-setup-account-request-payload";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ResendSMSForSetupAccountUsecase {
  //MARK:- Constructor
  constructor(private readonly patientRepo: PatientRepository) {}

  //MARK:- execute
  async execute(patientId: string): Promise<SATResult<void, SATError>> {
    const payload: ResendSMSForSetupAccountRequestPayload = {
      patientId: patientId,
    };
    const result = await this.patientRepo.resendSMSForSetupAccount(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(undefined);
  }
}
